import { getLoginInfo } from "../auth/getLoginInfo";
import { createAxiosWithToken, createAxios } from "./createAxios";

export async function Dashboard(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).get("/Report/Dashboard?FromDate=" + param.fromDate + "&ToDate=" + param.toDate + "&CenterId=" + param.centerId + "&IsCenter=" + param.isCenter)
}
export async function DailyReport(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).get("/Report/DailyCenter?CenterId=" + param.centerId)
}

//New Features
export async function ForDateCenter(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).get("/Report/ForDateCenter?CenterId=" + param.centerId + "&ForDate=" + param.ForDate)
}
//New Features
export async function DailySummary({ centerId, ForDate, Normal, NewEntry, Emergency }) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).get("/Report/DailySummary?CenterId=" + centerId + "&ForDate=" + ForDate + "&Normal=" + Normal + "&NewEntry=" + NewEntry+ "&Emergency=" + Emergency)
}
export async function GetPlan() {
    return await createAxios().get("/Report/GetPlan")
}